import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Dropdown, DropdownItem} from '@homeaway/react-dropdown';
import triggerEdapEvent from '../../utils/edap';

class LanguageSelector extends Component {

    static propTypes = {
        title: PropTypes.string,
        languageCode: PropTypes.string,
        languages: PropTypes.arrayOf(
            PropTypes.shape({
                languageCode: PropTypes.string,
                languageName: PropTypes.string
            })
        ),
        onChange: PropTypes.func
    }

    static defaultProps = {
        title: 'Language',
        languageCode: 'en_US',
        languages: [],
        onChange: () => {}
    }

    /* istanbul ignore next */
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(event, languageCode) {
        event.preventDefault();
        this.getLanguageNameByCode(languageCode);

        this.props.onChange(languageCode);
    }

    handleDropdownShow() {
        triggerEdapEvent({
            eventaction: 'display language dropdown clicked'
        });
    }

    getLanguageNameByCode(languageCode) {
        let currentLanguage = this.props.languages.filter((language) => {
            return language.languageCode === languageCode;
        })[0];
        this.languageName = currentLanguage ? currentLanguage.languageName : '';
    }

    render() {
        this.getLanguageNameByCode(this.props.languageCode);
        const {title, languages} = this.props;
        return (
            <div className="PreferenceSelector PreferenceSelector--language form-group">
                <div className="PreferenceSelector__title">{title}</div>
                <Dropdown
                    srOnlyLabel
                    label={title}
                    buttonChildren={<span className="PreferenceSelector__selected-option">{this.languageName}</span>}
                    id="language-selector"
                    name="language-selector"
                    onDropdownShow={this.handleDropdownShow}
                >
                    {languages.map((language) => {
                        return (
                            <DropdownItem
                                link="#"
                                text={language.languageName}
                                key={language.languageCode}
                                onClick={(event) => this.handleChange(event, language.languageCode)} // eslint-disable-line react/jsx-no-bind
                            />
                        );
                    })}
                </Dropdown>
            </div>
        );
    }
}

export default LanguageSelector;
